export default __webpack_public_path__ + "static/winByIn-af37a42f8fc9a49a87bf650690be45fe.png";